import { render } from "./SubmittedForm.vue?vue&type=template&id=32f0a81f&scoped=true"
import script from "./SubmittedForm.vue?vue&type=script&lang=js"
export * from "./SubmittedForm.vue?vue&type=script&lang=js"

import "./SubmittedForm.vue?vue&type=style&index=0&id=32f0a81f&lang=scss&scoped=true"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-32f0a81f"]])

export default __exports__